import { ResponsiveBar } from '@nivo/bar';
import React, { useState } from 'react'
import { ResponsivePie } from '@nivo/pie';
import { VeltNivoChartComments } from '@veltdev/react';

const dataset1 = [
    {
        "id": "scala",
        "label": "scala",
        "value": 178,
        "color": "hsl(207, 70%, 50%)"
    },
    {
        "id": "ruby",
        "label": "ruby",
        "value": 399,
        "color": "hsl(240, 70%, 50%)"
    },
    {
        "id": "rust",
        "label": "rust",
        "value": 456,
        "color": "hsl(193, 70%, 50%)"
    },
    {
        "id": "go",
        "label": "go",
        "value": 532,
        "color": "hsl(143, 70%, 50%)"
    },
    {
        "id": "hack",
        "label": "hack",
        "value": 430,
        "color": "hsl(65, 70%, 50%)"
    }
];

const dataset2 = [
    {
        "id": "scala",
        "label": "scala",
        "value": 278,
        "color": "hsl(207, 70%, 50%)"
    },
    {
        "id": "ruby",
        "label": "ruby",
        "value": 199,
        "color": "hsl(240, 70%, 50%)"
    },
    {
        "id": "rust",
        "label": "rust",
        "value": 156,
        "color": "hsl(193, 70%, 50%)"
    },
    {
        "id": "go",
        "label": "go",
        "value": 432,
        "color": "hsl(143, 70%, 50%)"
    },
    {
        "id": "hack",
        "label": "hack",
        "value": 630,
        "color": "hsl(65, 70%, 50%)"
    }
];

const dataset3 = [
    {
        "id": "scala",
        "label": "scala",
        "value": 378,
        "color": "hsl(207, 70%, 50%)"
    },
    {
        "id": "ruby",
        "label": "ruby",
        "value": 299,
        "color": "hsl(240, 70%, 50%)"
    },
    {
        "id": "rust",
        "label": "rust",
        "value": 176,
        "color": "hsl(193, 70%, 50%)"
    },
    {
        "id": "go",
        "label": "go",
        "value": 132,
        "color": "hsl(143, 70%, 50%)"
    },
    {
        "id": "hack",
        "label": "hack",
        "value": 230,
        "color": "hsl(65, 70%, 50%)"
    }
];

const datasets = {
    'dataset1': {
        id: 'dataset1',
        label: 'Dataset 1',
        data: JSON.parse(JSON.stringify(dataset1))
    },
    'dataset2': {
        id: 'dataset2',
        label: 'Dataset 2',
        data: JSON.parse(JSON.stringify(dataset2))
    },
    'dataset3': {
        id: 'dataset3',
        label: 'Dataset 3',
        data: JSON.parse(JSON.stringify(dataset3))
    },
}

function NivoPieChartExample() {

    const [selectedDataset, setSelectedDataset] = useState(datasets.dataset1);

    return (
        <div>
            <h3>Pie chart</h3>
            <div className='nivo-charts-tabs'>
                {
                    Object.values(datasets).map((dataset) => (
                        <div
                            key={dataset.id}
                            className={`nivo-charts-tab ${dataset?.id === selectedDataset?.id ? 'active' : ''}`}
                            onClick={() => setSelectedDataset(dataset)}
                        >
                            {dataset.label}
                        </div>
                    ))
                }
            </div>
            <div style={{ height: 400, width: '100%' }} className='nivo-chart-container'>
                <ResponsivePie
                    data={selectedDataset.data}
                    layers={[
                        'arcs',
                        'arcLinkLabels',
                        'arcLabels',
                        'legends',
                        (chartComputedData: any) => {
                            return (
                                <VeltNivoChartComments id="NivoPieChartExample" chartComputedData={chartComputedData} />
                            )
                        }
                    ]}
                    margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                    innerRadius={0.5}
                    padAngle={0.7}
                    cornerRadius={3}
                    activeOuterRadiusOffset={8}
                    borderWidth={1}
                    borderColor={{
                        from: 'color',
                        modifiers: [
                            [
                                'darker',
                                0.2
                            ]
                        ]
                    }}
                    arcLinkLabelsSkipAngle={10}
                    arcLinkLabelsTextColor="black"
                    arcLinkLabelsThickness={2}
                    arcLinkLabelsColor={{ from: 'color' }}
                    arcLabelsSkipAngle={10}
                    arcLabelsTextColor={{
                        from: 'color',
                        modifiers: [
                            [
                                'darker',
                                2
                            ]
                        ]
                    }}
                    defs={[
                        {
                            id: 'dots',
                            type: 'patternDots',
                            background: 'inherit',
                            color: 'rgba(255, 255, 255, 0.3)',
                            size: 4,
                            padding: 1,
                            stagger: true
                        },
                        {
                            id: 'lines',
                            type: 'patternLines',
                            background: 'inherit',
                            color: 'rgba(255, 255, 255, 0.3)',
                            rotation: -45,
                            lineWidth: 6,
                            spacing: 10
                        }
                    ]}
                    fill={[
                        {
                            match: {
                                id: 'ruby'
                            },
                            id: 'dots'
                        },
                        {
                            match: {
                                id: 'c'
                            },
                            id: 'dots'
                        },
                        {
                            match: {
                                id: 'go'
                            },
                            id: 'dots'
                        },
                        {
                            match: {
                                id: 'python'
                            },
                            id: 'dots'
                        },
                        {
                            match: {
                                id: 'scala'
                            },
                            id: 'lines'
                        },
                        {
                            match: {
                                id: 'lisp'
                            },
                            id: 'lines'
                        },
                        {
                            match: {
                                id: 'elixir'
                            },
                            id: 'lines'
                        },
                        {
                            match: {
                                id: 'javascript'
                            },
                            id: 'lines'
                        }
                    ]}
                    legends={[
                        {
                            anchor: 'bottom',
                            direction: 'row',
                            justify: false,
                            translateX: 0,
                            translateY: 56,
                            itemsSpacing: 0,
                            itemWidth: 100,
                            itemHeight: 18,
                            itemTextColor: '#999',
                            itemDirection: 'left-to-right',
                            itemOpacity: 1,
                            symbolSize: 18,
                            symbolShape: 'circle',
                            effects: [
                                {
                                    on: 'hover',
                                    style: {
                                        itemTextColor: '#fff'
                                    }
                                }
                            ]
                        }
                    ]}
                />
            </div>
        </div>
    )
}

export default NivoPieChartExample;